import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
import { useHublets } from './useHublets';
import { BETA_HUBLETS } from './betaHublets';
import { getActiveLoading } from '../store/loading-status/selectors';
import { useSelector } from 'react-redux';
import { getActiveError } from '../store/error/selectors';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBetaWarning = styled(UIAlert).withConfig({
  displayName: "HubletsBetaWarning__StyledBetaWarning",
  componentId: "sc-10rs7dg-0"
})(["@media ", "{width:50%;margin:0 auto;}"], devices.desktop);
const HubletsBetaWarning = () => {
  const title = I18n.text('views.HUBLET_SELECTION.betaWarning.title');
  const activeLoading = useSelector(getActiveLoading);
  const activeError = useSelector(getActiveError);
  const {
    hubletOptions
  } = useHublets();
  const hasBetaHublets = BETA_HUBLETS.some(hublet => hubletOptions.includes(hublet));
  const isNotLoading = !activeLoading;
  const isNotActiveError = !activeError;
  const {
    isAssignedToVariant: isACQ0162Variant
  } = useExperiment(ExperimentKeys.ACQ0162, TrackWhen.never);
  if (hasBetaHublets && isNotLoading && isNotActiveError && isACQ0162Variant()) {
    return /*#__PURE__*/_jsx(StyledBetaWarning, {
      titleText: title,
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "views.HUBLET_SELECTION.betaWarning.body"
      })
    });
  }
  return null;
};
export default HubletsBetaWarning;